import React, { Component } from 'react';
import { 
	GECKO_CONSTS, 
	GeckoToastService,
	GeckoModalService,
	GeckoModal,
} from '@geckolabs/gecko-react-ui';
import RsvpService from '../../../../services/RsvpService';
import Utils from '../../../../services/utils/utils';
import {__, STR_KEY} from '../../../../services/Translate';

export default class GuestCountModal extends Component {

	rsvpService = new RsvpService();

	state = { 
        // Minus 1 (the invitee) to get the guest count
		attendances_count: this.props.eventAttendance.attendances_count - 1,
	}

    makeGuestCountFieldOptions(maxNumberOfGuests)
    {
    	const array = [...Array(maxNumberOfGuests ? maxNumberOfGuests + 1 : 1).keys()]; 

	    const options = array.map(item => {
	        return {
	            label: item === 0 ? '0' : item.toString(),
	            value: item,
	        }
	    });

	    return options;
    }

    changeGuestCount()
    {
        const value = this.state.attendances_count;

    	if (value !== this.props.eventAttendance.guest_count) {
	        this.rsvpService.changeGuests(this.props.eventAttendance.id, value).then(response => {;
	        	window.location.reload();
	            // new GeckoToastService().success('Your number of guests was updated.');
	        }).catch(error => new GeckoToastService().error(error));
	    } else {
	    	new GeckoModalService().close();
	    }
    }

    render() {
		return (
            <GeckoModal 
            	fields={[
                	{
                		key: 'attendances_count',
                		label: __(STR_KEY.MODAL_GUESTS_TITLE),
                		type: GECKO_CONSTS.FIELD_TYPE_SELECT,
                		options: this.makeGuestCountFieldOptions(this.props.event.maximum_guests),
                        width: '100%'
                	}
                ]}
                values={this.state}
                handler={(key, value) => this.setState({[key]: value})}
                btns={[
                	{
                		name: __(STR_KEY.MODAL_GUESTS_BTN_NO),
                		handler: () => {
                            return new GeckoModalService().close();
                        },
                        secondary: true,
                	},{
                		name: __(STR_KEY.MODAL_GUESTS_BTN_YES),
                		handler: () => this.changeGuestCount(),
                		type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
                	},
                ]}
            />
        );
    }
}
